<template>
  <div>
    <div v-for="(trans, pi) in transactions" :key="'trans' + pi">
      <div v-if="trans.account && trans.amount && trans.currency">
        <strong>@{{ trans.account | uppercase }}</strong>
        <span class="no-br">
          {{ trans.amount | number(2) }}
          {{ trans.currency | translate }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["transactions"],
};
</script>

<style lang="scss" scoped>
.inner-table {
  width: 100%;
  tr {
    th,
    td {
      border: none;
      padding: 0;
    }
  }
}
</style>
